import React, { PropsWithChildren } from 'react'
import { Splide, SplideSlide, SplideTrack, Options } from '@splidejs/react-splide'
import { useTranslation } from 'next-i18next'
import { SliderContainer } from './styled'

interface ISliderProps {
  options?: Options
  dataTestId?: string
  slideStyle?: React.CSSProperties
  customElement?: React.ReactNode
  isRTL?: boolean
}

export const SliderImage = ({ src, alt, height, width }) => {
  return <img width={width} height={height} data-splide-lazy={src} alt={alt} />
}

const Slider: React.FunctionComponent<PropsWithChildren<ISliderProps>> = ({ children, options, dataTestId, slideStyle, customElement, isRTL = false, ...rest }) => {
  const { t } = useTranslation('common')

  const defaultOptions: Options = {
    direction: isRTL ? 'rtl' : 'ltr',
    lazyLoad: 'nearby',
    i18n: {
      prev: t('slider.prev'),
      next: t('slider.next'),
      first: t('slider.first'),
      last: t('slider.last'),
      slideX: t('slider.slideX'),
      pageX: t('slider.pageX'),
      play: t('slider.play'),
      pause: t('slider.pause'),
      carousel: t('slider.carousel'),
      slide: t('slider.slide'),
      select: t('slider.select'),
      slideLabel: t('slider.slideLabel'),
    },
  }

  const $$options: Options = {
    ...defaultOptions,
    ...options,
    i18n: {
      ...defaultOptions.i18n,
      ...options?.i18n,
    },
  }

  const sliderRef = React.useRef<any>(null)

  React.useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.go($$options.start)
    }
  }, [$$options.start])

  const renderChilds = () =>
    React.Children.map(children, (c, i) => {
      return (
        <SplideSlide style={slideStyle}>
          {
            //@ts-ignore
            React.cloneElement(c)
          }
        </SplideSlide>
      )
    })

  const $childs = renderChilds()

  return (
    <SliderContainer padding={$$options.padding}>
      {
        //@ts-ignore
        <Splide ref={sliderRef} options={$$options} hasTrack={false} dir={isRTL ? 'rtl' : 'ltr'}>
          <SplideTrack>{$childs}</SplideTrack>
          {customElement}
          <div className="splide__pagination" />
        </Splide>
      }
    </SliderContainer>
  )
}

export default Slider
